import { makeStyles } from 'tss-react/mui';

const useStylesListGroupHeader: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  listGroupHeader: {
    backgroundColor: `${theme.palette.primary.dark} !important`,
    color: theme.palette.common.white,
    borderTop: `1px solid ${theme.palette.background.default}`,
    padding: '5px 20px !important',
  },
}));

export default useStylesListGroupHeader;
